let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("blHiK")).then(() => parcelRequire('x3ONS'));